module.exports = __webpack_public_path__ + "img/110.52d542e4.png";